export const INDUSTRIAL_DISTRICT = 367
export const RAILWAY_DISTRICT = 6785
export const CENTRAL_DISTRICTS = 7229

export default [INDUSTRIAL_DISTRICT, RAILWAY_DISTRICT, CENTRAL_DISTRICTS]
